var path = 'app/scripts/modules/oracle/serverGroup/configure/wizard/capacity/capacitySelector.component.html';
var html = "<div>\n  <div class=\"form-group\">\n    <div class=\"col-md-12\">\n      <p>Select the number of instances</p>\n    </div>\n  </div>\n  <div class=\"form-group\">\n    <div class=\"col-md-3 sm-label-right\">Number of Instances</div>\n    <div class=\"col-md-2\"><input type=\"number\"\n                                 class=\"form-control input-sm\"\n                                 ng-model=\"vm.command.capacity.desired\"\n                                 min=\"1\"\n                                 required/></div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/oracle/serverGroup/configure/wizard/capacity/capacitySelector.component.html
// module id = 1713
// module chunks = 0